import { render } from "./UserHomepage.vue?vue&type=template&id=c827a018"
import script from "./UserHomepage.vue?vue&type=script&lang=js"
export * from "./UserHomepage.vue?vue&type=script&lang=js"

import "./UserHomepage.vue?vue&type=style&index=0&id=c827a018&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__